import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  AppstoreOutlined,
  HomeOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./BottomNavigation.css";

function BottomNavigation({ showApps = false }) {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);

  const items = [
    { to: "/subscription", label: "Подписка", icon: <HomeOutlined /> },
    ...(showApps ? [{ to: "/links", label: "Приложения", icon: <AppstoreOutlined /> }] : []),
    { to: "/profile", label: "Профиль", icon: <UserOutlined /> },
  ];

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <nav
      className={`bottom-nav ${isScrolled ? "bottom-nav--scrolled" : ""}`}
      aria-label="Основная навигация"
      style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
    >
      {items.map(({ to, label, icon }) => (
        <Link key={to} to={to} className={`bottom-nav__item ${isActive(to) ? "active" : ""}`}>
          <span className="bottom-nav__icon">{icon}</span>
          <span className="bottom-nav__label">{label}</span>
        </Link>
      ))}
    </nav>
  );
}

export default BottomNavigation;
